import React from 'react'
import { BoxItem, Wrapper } from './styled'
import btnMessageAdd from 'assets/images/message.png'
import btnMessage from 'assets/images/message-add.png'
import { useHistory } from 'react-router-dom'
import { UrlInternal } from 'common/constants/endpoints'
import { useDispatch, useSelector } from 'react-redux'
import types from 'store/actions/types'
import { isEmptyObject } from 'utils/ref'

type Props = {}

function MessageFixed({}: Props) {
  const dispatch = useDispatch()
  const history = useHistory()
  const { dataUser }: any = useSelector((state: any) => state.user)
  const handleOpenPopup = () => {
    if (isEmptyObject(dataUser)) {
      return dispatch({ type: types.OPEN_MODAL, payload: { name: 'login' } })
    }

    dispatch({ type: types.OPEN_MODAL, payload: { name: '1:1' } })
  }
  return (
    <Wrapper>
      <BoxItem onClick={() => history.push(UrlInternal.CUSTOMER_CENTER)}>
        {/* <span>고객센터</span> */}
        <img src={btnMessage} alt='' />
      </BoxItem>
      <BoxItem onClick={handleOpenPopup}>
        {/* <span>1:1 문의</span> */}
        <img src={btnMessageAdd} alt='' />
      </BoxItem>
    </Wrapper>
  )
}

export default MessageFixed
